import {
  VILUU_CONSENT_STORAGE_KEY,
  viluuHasNonEssentialConsent,
  viluuReadConsentFromCookie,
} from './consent';

window.ViluuConsent = {
  STORAGE_KEY: VILUU_CONSENT_STORAGE_KEY,
  hasNonEssentialConsent: viluuHasNonEssentialConsent,
  readFromCookie: viluuReadConsentFromCookie,
};
